// import the Tornis store function(s)
import { 
    watchViewport
} from 'tornis';

import { mobileNavigation } from './main-navigation';

let $html = document.querySelector('html'),
    $body = document.querySelector('body.site-layout'),
    buffer = 10,
    headerHidden = false,
    threshold = 80,
    bodyHeight = 0,
    lastScrollY = 0,
    t;

const eventHeaderHide = new Event('headerHide'),
    eventHeaderShow = new Event('headerShow');

// scroll functions

const toggleHeader = (mode) => { // true = show, false = hide
    if(mode && headerHidden) {
        $html.classList.remove('header-hidden');
        headerHidden = false;
        window.dispatchEvent(eventHeaderShow);
    } else if(!mode && !headerHidden) {
        $html.classList.add('header-hidden');
        headerHidden = true;
        window.dispatchEvent(eventHeaderHide);
    }
};

// define a watched function, to be run on each update
const updateScroll = ({scroll, size}) => {
    if (size.changed) {
        // set threshold
        threshold = parseInt(getComputedStyle($body,null).getPropertyValue('padding-top')) - buffer;
        // recalc body height
        bodyHeight = $body.offsetHeight;
    }
    if (size.changed || scroll.changed) {
        // page scrolled at all?
        $html.classList.toggle('page-scrolled', scroll.top > 0);
        // do something related to scroll position or velocity
        if(scroll.top > (lastScrollY + buffer) && scroll.top > threshold && !mobileNavigation.active) {
            clearTimeout(t);
            t = setTimeout(toggleHeader(false), 200);
            lastScrollY = scroll.top;
        } else if(scroll.bottom < bodyHeight && (scroll.top < (lastScrollY - buffer) || scroll.top <= threshold)) {
            clearTimeout(t);
            t = setTimeout(toggleHeader(true), 200);
            lastScrollY = scroll.top;
        }
    }
}

// bind the watch function
watchViewport(updateScroll);